import React from "react";
import AnswerChecker from "../AnswerChecker";

export default function Hands(props: any) {
  const { onNextGame } = props;

  return (
    <>
      <pre>
        10S 8H 1H 7S 9H 6S 7S 8H 5H 5H 1H 5S 12H 9H 5H 6S 7S 4H 1H 7S 5H 10S 5H
        8H 1H 9S 5H 8H 1H 4H 5H 1H 6S 7S 5H 5S
      </pre>
      <AnswerChecker
        onNextGame={onNextGame}
        correctAnswer="fb77f0bf7341f1e40ed24f4a95c22e59e46014e97b3521ac2869964497b93b3f"
      />
    </>
  );
}
